import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

import { DndContext, closestCenter } from "@dnd-kit/core";

import {
  SortableContext,
  useSortable,
  arrayMove,
  rectSortingStrategy,
} from "@dnd-kit/sortable";

import { CSS } from "@dnd-kit/utilities";

import "./../Styles/Beads.css";

import { API } from "../../config/api";

function SortableImage({ image, type, currentUserId, onDelete }) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id: image.id,
    });

  const style = {
    transform: CSS.Transform.toString(transform),

    transition,
  };

  return (
    <div ref={setNodeRef} style={style} className="bm_imgWrapper">
      <img
        src={`${API.BASE_URL}/uploads/${type}/${currentUserId}/${image.name}`}
        className="bm_oldImg"
        alt=""
      />

      <div className="bm_dragHandle" {...attributes} {...listeners}>
        <i className="bi bi-arrows-move"></i>
      </div>

      <button
        type="button"
        className="bm_removeImgBtn"
        onClick={() => onDelete(image.name)}
      >
        ✕
      </button>
    </div>
  );
}

// ==============================
// NEW IMAGE SORTABLE
// ==============================

function SortableNewImage({
  preview,

  id,

  onDelete,
}) {
  const {
    attributes,

    listeners,

    setNodeRef,

    transform,

    transition,
  } = useSortable({
    id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),

    transition,
  };

  return (
    <div ref={setNodeRef} style={style} className="bm_imgWrapper">
      <img src={preview} className="bm_oldImg" alt="" />

      <div className="bm_dragHandle" {...attributes} {...listeners}>
        <i className="bi bi-arrows-move"></i>
      </div>

      <button
        type="button"
        className="bm_removeImgBtn"
        onClick={() => onDelete(id)}
      >
        ✕
      </button>
    </div>
  );
}

// ==============================
// MAIN COMPONENT
// ==============================

export default function Supplier() {
  // URL TYPE
  // /user/beads
  // /user/thread
  // /user/sequin

  const { type } = useParams();

  const supplierType = type || "beads";

  const currentUserId = sessionStorage.getItem("userId") || "generic";
  const thumbnailRefs = useRef({});
  // ==============================
  // STATES
  // ==============================
  const [disableFreePlan, setDisableFreePlan] = useState(false);
  const [form, setForm] = useState({
    name: "",

    mobile: "",

    email: "",

    address: "",
  });

  const [user, setUser] = useState({});

  const [records, setRecords] = useState([]);

  const [images, setImages] = useState([]);

  const [existingImages, setExistingImages] = useState([]);

  const [removedImages, setRemovedImages] = useState([]);

  const [editId, setEditId] = useState(null);

  const [selectedImages, setSelectedImages] = useState({});

  const [search, setSearch] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const location = useLocation();
  const navigate = useNavigate();

  const isAdmin = location.pathname.startsWith("/admin");
  const [supplierTypes, setSupplierTypes] = useState([]);

  useEffect(() => {
    if (!isAdmin) return;

    fetch(`${API.BASE_URL}/api.php?action=supplier_types`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          setSupplierTypes(data.data);
        }
      })
      .catch(console.error);
  }, [isAdmin]);
  const rowsPerPage = 10;

  // ADS STATES

  const [adsPlans, setAdsPlans] = useState([]);

  const [adsData, setAdsData] = useState({
    show_ads_days: "",

    ads_amount: "",

    payment_screenshot: null,
  });

  const [timers, setTimers] = useState({});

  const [showRenewPopup, setShowRenewPopup] = useState(false);

  const [renewRecordId, setRenewRecordId] = useState(null);

  const [showProofModal, setShowProofModal] = useState(false);

  const [proofImage, setProofImage] = useState("");
  const [freePlanConfirm, setFreePlanConfirm] = useState(false);
  const [submitMode, setSubmitMode] = useState("");
  // Dynamic free plan column
  const freePlanField = `free_${supplierType}_plan`;
  const freePlanUsed = Number(user?.[freePlanField]) === 1;

  // const availablePlans = adsPlans.filter((plan) => {
  //   const isFree = Number(plan.amount) === 0;

  //   if (isFree && freePlanUsed) {
  //     return false;
  //   }

  //   return true;
  // });

  const availablePlans = adsPlans;
  const [popupData, setPopupData] = useState({
    open: false,
    images: [],
    index: 0,
    userId: null,
    supplierTable: "",
  });
  const [loading, setLoading] = useState(false);
  const openImagePopup = (recordId, img, userId, images, supplierTable) => {
    const index = images.findIndex((i) => i === img);

    setPopupData({
      open: true,
      images,
      index: index >= 0 ? index : 0,
      userId,
      supplierTable,
    });
  };
  useEffect(() => {
    if (!popupData.open) return;

    const handleKeyDown = (e) => {
      if (e.key === "ArrowRight") {
        setPopupData((prev) => ({
          ...prev,
          index:
            prev.index < prev.images.length - 1 ? prev.index + 1 : prev.index,
        }));
      }

      if (e.key === "ArrowLeft") {
        setPopupData((prev) => ({
          ...prev,
          index: prev.index > 0 ? prev.index - 1 : prev.index,
        }));
      }

      if (e.key === "Escape") {
        setPopupData((prev) => ({ ...prev, open: false }));
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [popupData.open]);
  // ==============================
  // GET USER
  // ==============================

  const fetchUserData = async () => {
    try {
      const userId = sessionStorage.getItem("userId");

      if (!userId) return;

      const res = await fetch(
        `${API.BASE_URL}/api.php?action=getuser&id=${userId}`,
      );

      const data = await res.json();

      if (data.success) {
        setUser(data.user);

        setForm((prev) => ({
          ...prev,

          name: data.user.name || "",

          mobile: data.user.phone || "",

          email: data.user.email || "",
        }));
      }
    } catch (err) {
      console.log(err);
    }
  };

  // ==============================
  // GET SUPPLIER RECORDS
  // ==============================

  const fetchSupplier = async () => {
    try {
      const userId = sessionStorage.getItem("userId");

      const res = await fetch(
        `${API.GET_SUPPLIER_USER}&type=${supplierType}&user_id=${userId}`,
      );

      const data = await res.json();

      setRecords(data.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  // ==============================
  // GET ADS PLANS
  // ==============================

  const fetchAdsPlans = async () => {
    try {
      const res = await fetch(`${API.GET_ADS_PLANS}&type=supplier`);

      const data = await res.json();

      if (data.status) {
        setAdsPlans(data.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // ==============================
  // INITIAL LOAD
  // ==============================

  useEffect(() => {
    fetchUserData();

    fetchSupplier();

    fetchAdsPlans();
  }, [supplierType]);

  // ==============================
  // ADS TIMER
  // ==============================

  useEffect(() => {
    const interval = setInterval(() => {
      let obj = {};

      records.forEach((item) => {
        if (item.ads_status === "active") {
          let diff = new Date(item.ads_end_date) - new Date();

          if (diff <= 0) {
            obj[item.id] = "expired";
          } else {
            let d = Math.floor(diff / (1000 * 60 * 60 * 24));

            let h = Math.floor((diff / (1000 * 60 * 60)) % 24);

            let m = Math.floor((diff / (1000 * 60)) % 60);

            let s = Math.floor((diff / 1000) % 60);

            obj[item.id] = `${d}d ${h}h ${m}m ${s}s`;
          }
        }
      });

      setTimers(obj);
    }, 1000);

    return () => clearInterval(interval);
  }, [records]);

  // ==============================
  // IMAGE UPLOAD
  // ==============================

  const handleFiles = (e) => {
    const files = Array.from(e.target.files);

    if (files.length === 0) return;

    // ==============================
    // MAX 5 MB PER IMAGE
    // ==============================
    const maxFileSize = 5 * 1024 * 1024; // 5 MB

    const oversizedFiles = files.filter((file) => file.size > maxFileSize);

    if (oversizedFiles.length > 0) {
      alert(
        `Each image must be 5 MB or smaller.\n\n` +
          `Too large: ${oversizedFiles.map((file) => file.name).join(", ")}`,
      );

      e.target.value = "";
      return;
    }

    // ==============================
    // MAX 10 IMAGES
    // ==============================
    if (images.length + files.length > 10) {
      alert("Maximum 10 images allowed.");

      e.target.value = "";
      return;
    }

    // ==============================
    // ADD IMAGES
    // ==============================
    const newImages = files.map((file) => ({
      id: crypto.randomUUID(),
      file,
      preview: URL.createObjectURL(file),
    }));

    setImages((prev) => [...prev, ...newImages]);

    e.target.value = "";
  };

  // ==============================
  // REMOVE NEW IMAGE
  // ==============================

  const removeNewImage = (id) => {
    setImages((prev) => {
      const img = prev.find((i) => i.id === id);

      if (img) {
        URL.revokeObjectURL(img.preview);
      }

      return prev.filter((i) => i.id !== id);
    });
  };

  // ==============================
  // NEW IMAGE DRAG SORT
  // ==============================

  const handleNewDragEnd = (event) => {
    const { active, over } = event;

    if (!over || active.id === over.id) return;

    setImages((items) => {
      const oldIndex = items.findIndex((i) => i.id === active.id);

      const newIndex = items.findIndex((i) => i.id === over.id);

      return arrayMove(items, oldIndex, newIndex);
    });
  };

  // ==============================
  // OLD IMAGE DRAG SORT
  // ==============================

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (!over || active.id === over.id) return;

    setExistingImages((items) => {
      const oldIndex = items.findIndex((i) => i.id === active.id);

      const newIndex = items.findIndex((i) => i.id === over.id);

      return arrayMove(
        items,

        oldIndex,

        newIndex,
      );
    });
  };

  // ==============================
  // DELETE OLD IMAGE FROM EDIT
  // ==============================

  const handleRemoveExistingImage = (name) => {
    // remove from preview
    setExistingImages((prev) => prev.filter((img) => img.name !== name));

    // store deleted image names for backend
    setRemovedImages((prev) => {
      if (prev.includes(name)) return prev;

      return [...prev, name];
    });
  };

  // ==============================
  // FORM CHANGE
  // ==============================

  const handleChange = (e) => {
    setForm({
      ...form,

      [e.target.name]: e.target.value,
    });
  };

  // ==============================
  // SELECT IMAGE CARD
  // ==============================

  const handleSelectImage = (id, img) => {
    setSelectedImages((prev) => ({
      ...prev,

      [id]: img,
    }));
  };

  // ==============================
  // EDIT RECORD
  // ==============================

  const handleEdit = (item) => {
    setForm({
      name: item.name || "",

      mobile: item.mobile || "",

      email: item.email || "",

      address: item.address || "",
    });

    setEditId(item.id);

    setExistingImages(
      (item.images || []).map((img, index) => ({
        id: `${index}-${img}`,

        name: img,
      })),
    );

    setImages([]);

    setRemovedImages([]);

    setAdsData({
      show_ads_days: item.show_ads_days || "",

      ads_amount: item.ads_amount || "",

      payment_screenshot: null,
    });

    window.scrollTo({
      top: 0,

      behavior: "smooth",
    });
  };

  // ==============================
  // RESET FORM
  // ==============================

  const resetForm = () => {
    setForm({
      name: user.name || "",
      mobile: user.phone || "",
      email: user.email || "",
      address: "",
    });

    setImages([]);

    setExistingImages([]);

    setRemovedImages([]);

    setEditId(null);

    setSelectedImages({});

    setAdsData({
      show_ads_days: "",
      ads_amount: "",
      payment_screenshot: null,
    });

    // Clear file input
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) fileInput.value = "";
  };
  // ==============================
  // SUBMIT ADD / UPDATE
  // ==============================

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   const fd = new FormData();
  //   fd.append("submit_mode", submitMode);
  //   fd.append("type", supplierType);

  //   fd.append("name", form.name);

  //   fd.append("mobile", form.mobile);

  //   fd.append("email", form.email);

  //   fd.append("address", form.address);

  //   fd.append("user_id", currentUserId);

  //   // ================= UPDATE =================

  //   if (editId) {
  //     fd.append("id", editId);

  //     // Remaining old images
  //     fd.append(
  //       "existing_images",
  //       JSON.stringify(existingImages.map((img) => img.name)),
  //     );

  //     // Deleted old images only
  //     fd.append("remove_images", removedImages.join(","));

  //     // Current image order
  //     fd.append("image_order", existingImages.map((img) => img.name).join(","));
  //   }

  //   // ================= ADS DATA =================

  //   fd.append("show_ads_days", adsData.show_ads_days || "");

  //   fd.append("ads_amount", adsData.ads_amount || "");

  //   if (adsData.payment_screenshot) {
  //     fd.append("payment_screenshot", adsData.payment_screenshot);
  //   }
  //   if (submitMode === "send") {
  //     fd.append("ads_status", "pending");
  //   }
  //   // ================= NEW IMAGES =================

  //   images.forEach((img) => {
  //     fd.append("images[]", img.file);
  //   });

  //   const url = editId ? API.UPDATE_SUPPLIER : API.ADD_SUPPLIER;

  //   setLoading(true);

  //   try {
  //     const res = await fetch(url, {
  //       method: "POST",
  //       body: fd,
  //     });

  //     const text = await res.text();

  //     console.log(text);

  //     const result = JSON.parse(text);

  //     if (result.status) {
  //       alert(result.message);

  //       resetForm();

  //       await fetchSupplier();

  //       await fetchUserData();
  //     } else {
  //       if (result.message === "Free plan already used.") {
  //         setFreePlanConfirm(true);

  //         // Optional: clear selected plan
  //         setAdsData((prev) => ({
  //           ...prev,
  //           show_ads_days: "",
  //           ads_amount: "",
  //         }));

  //         return;
  //       }

  //       alert(result.message);
  //     }
  //   } catch (err) {
  //     console.error(err);

  //     alert(err.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation: Minimum one image required
    if (!editId && images.length === 0) {
      alert("Please upload at least one image.");
      return;
    }

    // Validation while editing
    if (editId && existingImages.length === 0 && images.length === 0) {
      alert("Please keep or upload at least one image.");
      return;
    }

    const fd = new FormData();

    fd.append("submit_mode", submitMode);
    fd.append("type", supplierType);
    fd.append("name", form.name);
    fd.append("mobile", form.mobile);
    fd.append("email", form.email);
    fd.append("address", form.address);
    fd.append("user_id", currentUserId);

    // ================= UPDATE =================

    if (editId) {
      fd.append("id", editId);

      // Remaining old images
      fd.append(
        "existing_images",
        JSON.stringify(existingImages.map((img) => img.name)),
      );

      // Deleted old images only
      fd.append("remove_images", removedImages.join(","));

      // Current image order
      fd.append("image_order", existingImages.map((img) => img.name).join(","));
    }

    // ================= ADS DATA =================

    fd.append("show_ads_days", adsData.show_ads_days || "");

    fd.append("ads_amount", adsData.ads_amount || "");

    if (adsData.payment_screenshot) {
      fd.append("payment_screenshot", adsData.payment_screenshot);
    }
    if (submitMode === "send") {
      fd.append("ads_status", "pending");
    }
    // ================= NEW IMAGES =================

    images.forEach((img) => {
      fd.append("images[]", img.file);
    });

    const url = editId ? API.UPDATE_SUPPLIER : API.ADD_SUPPLIER;

    setLoading(true);

    try {
      const res = await fetch(url, {
        method: "POST",
        body: fd,
      });

      const text = await res.text();

      const result = JSON.parse(text);

      if (result.status) {
        alert(result.message);

        resetForm();

        await fetchSupplier();

        await fetchUserData();
      } else {
        if (result.message === "Free plan already used.") {
          setFreePlanConfirm(true);

          // Optional: clear selected plan
          setAdsData((prev) => ({
            ...prev,
            show_ads_days: "",
            ads_amount: "",
          }));

          return;
        }

        alert(result.message);
      }
    } catch (err) {
      console.error(err);

      alert(err.message);
    } finally {
      setLoading(false);
    }
  };
  // ==============================
  // DELETE RECORD
  // ==============================

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete?")) return;

    const fd = new FormData();

    fd.append("id", id);
    fd.append("user_id", currentUserId);
    fd.append("type", supplierType);

    try {
      const res = await fetch(API.DELETE_SUPPLIER, {
        method: "POST",
        body: fd,
      });

      const result = await res.json();

      if (result.status) {
        alert(result.message);

        // Clear edit form if deleting edited record
        if (editId === id) {
          resetForm();
        }

        await fetchSupplier();
        await fetchUserData();
      } else {
        alert(result.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // ==============================
  // RENEW ADS
  // ==============================

  const handleRenewAds = (item) => {
    setRenewRecordId(item.id);

    setAdsData({
      show_ads_days: "",

      ads_amount: "",

      payment_screenshot: null,
    });

    setShowRenewPopup(true);
  };

  const handleRenewSubmit = async () => {
    if (!renewRecordId) return;

    const fd = new FormData();

    fd.append("type", supplierType);

    fd.append("id", renewRecordId);

    fd.append("user_id", currentUserId);

    fd.append(
      "show_ads_days",

      adsData.show_ads_days,
    );

    fd.append(
      "ads_amount",

      adsData.ads_amount,
    );

    if (adsData.payment_screenshot) {
      fd.append(
        "payment_screenshot",

        adsData.payment_screenshot,
      );
    }

    try {
      const res = await fetch(
        API.RENEW_SUPPLIER_ADS,

        {
          method: "POST",

          body: fd,
        },
      );

      const data = await res.json();

      if (data.status) {
        alert("Ads renewal request submitted");

        setShowRenewPopup(false);

        setRecords((prev) =>
          prev.map((item) =>
            item.id === renewRecordId
              ? {
                  ...item,
                  ads_status: "pending",
                }
              : item,
          ),
        );

        fetchSupplier();
      }
    } catch (err) {
      console.log(err);
    }
  };

  // ==============================
  // SEARCH + PAGINATION
  // ==============================

  const filteredData = records.filter((item) => {
    const key = search.toLowerCase();

    return (
      item.name?.toLowerCase().includes(key) ||
      item.mobile?.includes(key) ||
      item.email?.toLowerCase().includes(key)
    );
  });

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const displayedRows = filteredData.slice(
    (currentPage - 1) * rowsPerPage,

    currentPage * rowsPerPage,
  );

  return (
    <div className="bm_page">
      <div className="bm_container">
        {/* HEADER */}

        <div className="bm_header">
          <div>
            <h1>Add {supplierType.toUpperCase()} Records</h1>
          </div>

          <div className="bm_totalCard">Total Records: {records.length}</div>
        </div>

        <div className="bm_layout">
          {/* ================= FORM ================= */}

          <div className="bm_formPanel">
            <h2>{editId ? "Update Record" : "Add Record"}</h2>
            {isAdmin && (
              <div className="bm_field">
                <label>Supplier Type</label>

                <select
                  value={supplierType}
                  onChange={(e) => navigate(`/admin/${e.target.value}`)}
                >
                  {supplierTypes.map((item) => (
                    <option key={item.id} value={item.type}>
                      {item.display_name}
                    </option>
                  ))}
                </select>
              </div>
            )}
            <form
              onSubmit={(e) => {
                e.preventDefault();

                const selectedPlan = adsPlans.find(
                  (p) => String(p.days) === String(adsData.show_ads_days),
                );

                const isFreePlan = Number(selectedPlan?.amount) === 0;

                if (isFreePlan && freePlanUsed) {
                  setFreePlanConfirm(true);
                  return;
                }

                handleSubmit(e);
              }}
            >
              <div className="bm_field">
                <label>Name</label>

                <input
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="bm_field">
                <label>Mobile</label>

                <input
                  name="mobile"
                  value={form.mobile}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="bm_field">
                <label>Email</label>

                <input
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                />
              </div>

              <div className="bm_field">
                <label>Address</label>

                <textarea
                  name="address"
                  value={form.address}
                  onChange={handleChange}
                />
              </div>

              <div className="bm_field">
                <label>
                  Images
                  <small style={{ color: "#ac1313" }}>(Max 10)</small>
                </label>

                <input type="file" multiple onChange={handleFiles} />
              </div>

              {/* NEW IMAGES */}

              {images.length > 0 && (
                <DndContext
                  collisionDetection={closestCenter}
                  onDragEnd={handleNewDragEnd}
                >
                  <SortableContext
                    items={images.map((i) => i.id)}
                    strategy={rectSortingStrategy}
                  >
                    <div className="bm_previewRow">
                      {images.map((img) => (
                        <SortableNewImage
                          key={img.id}
                          id={img.id}
                          preview={img.preview}
                          onDelete={removeNewImage}
                        />
                      ))}
                    </div>
                  </SortableContext>
                </DndContext>
              )}

              {/* OLD IMAGES */}

              {editId && existingImages.length > 0 && (
                <DndContext
                  collisionDetection={closestCenter}
                  onDragEnd={handleDragEnd}
                >
                  <SortableContext
                    items={existingImages.map((i) => i.id)}
                    strategy={rectSortingStrategy}
                  >
                    <div className="bm_previewRow">
                      {existingImages.map((img) => (
                        <SortableImage
                          key={img.id}
                          image={img}
                          type={supplierType}
                          currentUserId={currentUserId}
                          onDelete={handleRemoveExistingImage}
                        />
                      ))}
                    </div>
                  </SortableContext>
                </DndContext>
              )}

              {/* ADS PLAN */}

              {/* <div className="bm_field">
                <label>Show Ads For</label>

                <select
                  value={adsData.show_ads_days}
                  onChange={(e) => {
                    const plan = adsPlans.find(
                      (p) => String(p.days) === e.target.value,
                    );

                    const isFree = Number(plan.amount) === 0;

                    if (isFree && freePlanUsed) {
                      setFreePlanConfirm(true);

                      return;
                    }

                    setAdsData({
                      ...adsData,
                      show_ads_days: e.target.value,
                      ads_amount: plan.amount,
                    });
                  }}
                >
                  <option value="">Select Days</option>

                  {adsPlans.map((plan) => {
                    const isFree = Number(plan.amount) === 0;

                    return (
                      <option
                        key={plan.id}
                        value={plan.days}
                        disabled={isFree && (disableFreePlan || !!editId)}
                      >
                        {plan.days} Days - ₹{plan.amount}
                        {isFree && (disableFreePlan || !!editId)
                          ? " (Already Used)"
                          : ""}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className="bm_field">
                <label>Amount</label>

                <input readOnly value={adsData.ads_amount} />
              </div>

              {adsData.ads_amount !== "0" && adsData.show_ads_days && (
                <>
                  <div className="bm_field">
                    <label>Scan & Pay</label>

                    <img src="/images/qr.jpeg" width="200" alt="QR" />
                  </div>

                  <div className="bm_field">
                    <label>Payment Screenshot</label>

                    <input
                      type="file"
                      onChange={(e) =>
                        setAdsData({
                          ...adsData,

                          payment_screenshot: e.target.files[0],
                        })
                      }
                    />
                  </div>
                </>
              )} */}

              <div className="bm_formActions">
                <button
                  type="submit"
                  className="bm_submitBtn"
                  disabled={loading}
                >
                  {loading
                    ? "Please Wait..."
                    : editId
                      ? "Update Record"
                      : "Save Record"}
                </button>

                {editId && (
                  <button
                    type="button"
                    className="bm_cancelBtn"
                    onClick={resetForm}
                  >
                    Cancel
                  </button>
                )}
              </div>
            </form>
          </div>

          {/* ================= RECORD PANEL ================= */}

          <div className="bm_tablePanel">
            <div className="bm_tableHeader">
              <h2>Records Panel</h2>

              <input
                className="bm_searchBox"
                placeholder="Search records..."
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);

                  setCurrentPage(1);
                }}
              />
            </div>

            <div className="bm_cardsGrid">
              {filteredData.map((item) => (
                <div className="bm_recordCard" key={item.id}>
                  <span
                    className={`bm_cardStatus ${item.status.toLowerCase()}`}
                  >
                    {item.status}
                  </span>

                  <div className="bm_mainPreview">
                    <img
                      src={
                        selectedImages[item.id]
                          ? `${API.BASE_URL}/uploads/${supplierType}/${currentUserId}/${selectedImages[item.id]}`
                          : item.images?.[0]
                            ? `${API.BASE_URL}/uploads/${supplierType}/${currentUserId}/${item.images[0]}`
                            : "https://via.placeholder.com/400"
                      }
                      className="designer-img"
                      alt={item.name}
                      onClick={() =>
                        openImagePopup(
                          item.id,
                          selectedImages[item.id] || item.images?.[0],
                          item.user_id,
                          item.images,
                          item.supplier_table,
                        )
                      }
                      style={{ cursor: "pointer" }}
                    />
                    {item.images?.length > 1 && (
                      <button
                        className="supNavArrow supNavArrowLeft"
                        onClick={() => {
                          const current = selectedImages[item.id]
                            ? item.images.indexOf(selectedImages[item.id])
                            : 0;

                          const prevIndex =
                            current > 0 ? current - 1 : item.images.length - 1;

                          setSelectedImages((prev) => ({
                            ...prev,
                            [item.id]: item.images[prevIndex],
                          }));
                        }}
                      >
                        <i className="bi bi-chevron-left"></i>
                      </button>
                    )}

                    {/* RIGHT BUTTON */}
                    {item.images?.length > 1 && (
                      <button
                        className="supNavArrow supNavArrowRight"
                        onClick={() => {
                          const current = selectedImages[item.id]
                            ? item.images.indexOf(selectedImages[item.id])
                            : 0;

                          const nextIndex =
                            current < item.images.length - 1 ? current + 1 : 0;

                          setSelectedImages((prev) => ({
                            ...prev,
                            [item.id]: item.images[nextIndex],
                          }));
                        }}
                      >
                        <i className="bi bi-chevron-right"></i>
                      </button>
                    )}

                    {/* IMAGE COUNT */}
                    {item.images?.length > 1 && (
                      <div className="image-count">
                        <i className="bi bi-images me-1"></i>+
                        {item.images.length - 1}
                      </div>
                    )}
                  </div>

                  <div className="bm_cardImages">
                    {item.images?.map((img, i) => (
                      // <img
                      //   key={i}
                      //   src={`${API.BASE_URL}/uploads/${supplierType}/user_${currentUserId}/${img}`}
                      //   className="bm_cardImg"
                      //   alt=""
                      //   onClick={() => handleSelectImage(item.id, img)}
                      // />
                      <img
                        key={i}
                        src={`${API.BASE_URL}/uploads/${supplierType}/${currentUserId}/${img}`}
                        alt="thumbnail"
                        className={`card-thumbnail ${
                          selectedImages[item.id] === img ||
                          (!selectedImages[item.id] && i === 0)
                            ? "active-thumb"
                            : ""
                        }`}
                        onClick={() => {
                          openImagePopup(
                            item.id,
                            img,
                            item.user_id,
                            item.images,
                            item.supplier_table,
                          );

                          setTimeout(() => {
                            thumbnailRefs.current[item.id]?.children[
                              i
                            ]?.scrollIntoView({
                              behavior: "smooth",
                              inline: "center",
                              block: "nearest",
                            });
                          }, 100);
                        }}
                      />
                    ))}
                  </div>
                  <div className="bm_cardContent">
                    <h3 className="bm_name">{item.name}</h3>
                    <div className="bm_cardInfo">
                      <span>
                        <strong>Mobile No:</strong> {item.mobile}
                      </span>
                      <span>
                        <strong>Email:</strong> {item.email || "—"}
                      </span>
                    </div>

                    {item.address && (
                      <p className="bm_address">{item.address}</p>
                    )}

                    {/* {item.ads_status === "expired" ||
                    item.ads_status === "rejected" ? (
                      <button
                        className="bm_submitBtn1"
                        onClick={() => handleRenewAds(item)}
                      >
                        Renew Ads
                      </button>
                    ) : item.ads_status === "pending" ? (
                      <div className="ad_timer" style={{ color: "#f39c12" }}>
                        Renewal Pending Approval
                      </div>
                    ) : (
                      timers[item.id] &&
                      timers[item.id] !== "expired" && (
                        <div className="ad_timer">
                          Ads Active : {timers[item.id]}
                        </div>
                      )
                    )}
                    <div className="bm_adsBox">
                      <div className="bm_adsHeader">
                        <i className="bi bi-megaphone-fill"></i>
                        <span>Ads Details</span>
                      </div>

                      <div className="bm_adsBody">
                        <div className="bm_adsItem">
                          <strong>Status:</strong>
                          <span
                            className={`bm_adsStatus ${
                              item.ads_status?.toLowerCase() || "inactive"
                            }`}
                          >
                            {item.ads_status || "Inactive"}
                          </span>
                        </div>

                        <div className="bm_adsItem">
                          <strong>Days:</strong>
                          <span>{item.show_ads_days || 0}</span>
                        </div>

                        <div className="bm_adsItem">
                          <strong>Amount:</strong>
                          <span>₹{item.ads_amount || 0}</span>
                        </div>

                        {item.ads_end_date && (
                          <div className="bm_adsItem">
                            <strong>End Date:</strong>
                            <span>
                              {new Date(item.ads_end_date).toLocaleDateString(
                                "en-GB",
                              )}
                            </span>
                          </div>
                        )}

                        {item.payment_screenshot && (
                          <button
                            type="button"
                            className="bm_paymentLink"
                            onClick={() => {
                              setProofImage(
                                `${API.BASE_URL}/uploads/${supplierType}/${item.user_id}/${item.payment_screenshot}`,
                              );
                              setShowProofModal(true);
                            }}
                          >
                            <i className="bi bi-receipt-cutoff"></i>
                            View Payment Proof
                          </button>
                        )}
                      </div>
                    </div> */}
                    <div className="bm_cardFooter">
                      <button
                        className="bm_editBtn"
                        onClick={() => handleEdit(item)}
                      >
                        Edit
                      </button>

                      <button
                        className="bm_deleteBtn"
                        onClick={() => handleDelete(item.id)}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* RENEW POPUP */}

      {showRenewPopup && (
        <div className="renew_modal_overlay">
          <div className="renew_modal">
            <h3>Renew Advertisement</h3>

            <select
              value={adsData.show_ads_days}
              onChange={(e) => {
                const plan = adsPlans.find(
                  (p) => String(p.days) === String(e.target.value),
                );

                setAdsData({
                  ...adsData,

                  show_ads_days: e.target.value,

                  ads_amount: plan?.amount || "",
                });
              }}
            >
              <option>Select Plan</option>

              {availablePlans.map((plan) => (
                <option key={plan.id} value={plan.days}>
                  {plan.days} Days - ₹{plan.amount}
                </option>
              ))}
            </select>

            <input readOnly value={adsData.ads_amount} />
            {adsData.ads_amount !== "0" && adsData.show_ads_days && (
              <>
                <div className="bm_field">
                  <label>Scan & Pay</label>

                  <img src="/images/qr.jpeg" width="200" alt="QR" />
                </div>

                <div className="bm_field">
                  <label>Payment Screenshot</label>

                  <input
                    type="file"
                    onChange={(e) =>
                      setAdsData({
                        ...adsData,
                        payment_screenshot: e.target.files[0],
                      })
                    }
                  />
                </div>
              </>
            )}
            <button className="bm_submitBtn" onClick={handleRenewSubmit}>
              Submit Renewal
            </button>

            <button
              className="bm_cancelBtn"
              onClick={() => setShowRenewPopup(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* PAYMENT PROOF */}

      {showProofModal && (
        <div className="proof_modal_overlay">
          <div className="proof_modal">
            <button
              className="proof_close"
              onClick={() => setShowProofModal(false)}
            >
              ✕
            </button>

            <img
              src={proofImage}
              alt="proof"
              style={{
                width: "100%",

                maxHeight: "80vh",

                objectFit: "contain",
              }}
            />
          </div>
        </div>
      )}
      {popupData.open && (
        <div
          className="beads-image-popup-overlay"
          onClick={() => setPopupData((p) => ({ ...p, open: false }))}
        >
          <div
            className="beads-image-popup-box"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="beads-image-popup-close"
              onClick={() => setPopupData((p) => ({ ...p, open: false }))}
            >
              ✕
            </button>

            <img
              className="beads-image-popup-img"
              src={`${API.BASE_URL}/uploads/${supplierType}/${popupData.userId}/${popupData.images[popupData.index]}`}
              alt="Preview"
            />

            <button
              className="beads-image-popup-nav beads-image-popup-left"
              onClick={() =>
                setPopupData((p) => ({
                  ...p,
                  index: Math.max(0, p.index - 1),
                }))
              }
            >
              <i className="bi bi-chevron-left"></i>
            </button>

            <button
              className="beads-image-popup-nav beads-image-popup-right"
              onClick={() =>
                setPopupData((p) => ({
                  ...p,
                  index: Math.min(p.images.length - 1, p.index + 1),
                }))
              }
            >
              <i className="bi bi-chevron-right"></i>
            </button>
          </div>
        </div>
      )}

      {freePlanConfirm && (
        <div className="beads-freeplan-overlay">
          <div className="beads-freeplan-popup">
            <h3>
              <i className="bi bi-info-circle"></i>
              Free Plan Already Used
            </h3>

            <p>
              You have already used your free plan. Do you want to edit your ads
              option or send request for approval?
            </p>

            <div className="beads-freeplan-actions">
              <button
                type="button"
                className="beads-freeplan-send"
                onClick={() => {
                  setSubmitMode("send");
                  setFreePlanConfirm(false);

                  setTimeout(() => {
                    handleSubmit({
                      preventDefault: () => {},
                    });
                  }, 100);
                }}
              >
                Send Request
              </button>

              <button
                className="beads-freeplan-edit"
                onClick={() => {
                  setSubmitMode("edit");
                  setFreePlanConfirm(false);

                  // Disable free plan from now on
                  setDisableFreePlan(true);

                  setAdsData({
                    ...adsData,
                    show_ads_days: "",
                    ads_amount: "",
                  });
                }}
              >
                Edit Ads Option
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
